/**
 * CardElement — F12.H T12.H.3.
 *
 * Karta — wrapper z cieniem + opcjonalny tytuł + treść/children. Typowy
 * container do wizualnego grupowania pól (np. „Dane klienta", „Adres
 * dostawy"). Różni się od PanelElement obecnością shadow + większego
 * padding'u.
 *
 * Settings: { title?, padding?: 'sm'|'md'|'lg', shadow?: boolean }
 */

import type { LayoutElementDefinition } from '@/components/fields/LayoutElementRegistry';

const PADDING_CLASS: Record<string, string> = {
  sm: 'p-2',
  md: 'p-4',
  lg: 'p-6',
};

export const CardElement: LayoutElementDefinition = {
  type: 'card',
  category: 'kontenery',
  isContainer: true,
  label: 'Karta',
  icon: 'CreditCard',
  defaultSettings: () => ({
    title: '',
    padding: 'md',
    shadow: true,
  }),
  render: ({ element, children, mode }) => {
    const settings = (element.settings ?? {}) as {
      title?: string;
      padding?: 'sm' | 'md' | 'lg';
      shadow?: boolean;
    };
    const paddingCls = PADDING_CLASS[settings.padding ?? 'md'] ?? 'p-4';
    const shadowCls = settings.shadow !== false ? 'shadow-sm' : '';
    const isBuilder = mode === 'builder';

    return (
      <div
        className={`rounded-lg border border-border-primary bg-bg-primary ${paddingCls} ${shadowCls} ${isBuilder ? 'ring-2 ring-transparent hover:ring-accent-200 transition' : ''}`}
        data-testid={`card-element-${element.id}`}
        data-element-type="card"
      >
        {settings.title && (
          <h3 className="mb-3 text-sm font-semibold text-text-primary">{settings.title}</h3>
        )}
        {children.length > 0 ? (
          <div className="space-y-3">{children}</div>
        ) : isBuilder ? (
          <p className="text-xs italic text-text-muted">(karta pusta — przeciągnij elementy)</p>
        ) : null}
      </div>
    );
  },
};
